import { render } from "./PlayerFiltersForm.vue?vue&type=template&id=3b563b9b"
import script from "./PlayerFiltersForm.vue?vue&type=script&lang=js"
export * from "./PlayerFiltersForm.vue?vue&type=script&lang=js"

import "./PlayerFiltersForm.vue?vue&type=style&index=0&id=3b563b9b&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__